// import settings from 'config/settings';
import { EnumLiteralsOf } from './types';

export const spriteFrameSize = {
  xxs: 'xxs' as 'xxs',
  xs: 'xs' as 'xs',
  s: 's' as 's',
  m: 'm' as 'm',
  l: 'l' as 'l'
};
export type SpriteFrameSize = EnumLiteralsOf<typeof spriteFrameSize>;

export class Sprite {
  static getNumberOfFramesBySize(size: SpriteFrameSize = spriteFrameSize.s) {
    switch (size) {
      case spriteFrameSize.xxs:
      case spriteFrameSize.xs:
      case spriteFrameSize.s:
      case spriteFrameSize.m:
        return 676;

      case spriteFrameSize.l:
        return 66;

      default:
        return 66;
    }
  }

  static getUrl(frameNumber = 1, project, size: SpriteFrameSize = spriteFrameSize.s) {
    // console.log({ project });
    if (!project) return null;

    // const folderName = {
    //   [spriteFrameSize.xxs]: spriteFrameSize.s,
    //   [spriteFrameSize.xs]: spriteFrameSize.s,
    //   [spriteFrameSize.s]: spriteFrameSize.s,
    //   [spriteFrameSize.m]: spriteFrameSize.s,
    //   [spriteFrameSize.l]: spriteFrameSize.l
    // }[size] || spriteFrameSize.s;

    const spriteUrl = {
      [spriteFrameSize.xxs]: project.urlSpriteS,
      [spriteFrameSize.xs]: project.urlSpriteS,
      [spriteFrameSize.s]: project.urlSpriteS,
      [spriteFrameSize.m]: project.urlSpriteS,
      [spriteFrameSize.l]: project.urlSpriteL
    }[size] || project.urlSpriteS;

    const numberOfFrames = this.getNumberOfFramesBySize(size);
    const isFrameLastInSprite = frameNumber % numberOfFrames === 0;
    const spriteNumber = Math.floor(frameNumber / numberOfFrames) + (isFrameLastInSprite ? 0 : 1);
    const url = `${spriteUrl}/${spriteNumber}.jpg`;
    // const url = `${settings.spriteUrl}/${projectId}/${folderName}/${spriteNumber}.jpg`;
    return url;
  }

  static getFramesPerLine(size: SpriteFrameSize = spriteFrameSize.s) {
    switch (size) {
      case spriteFrameSize.xxs:
      case spriteFrameSize.xs:
      case spriteFrameSize.s:
      case spriteFrameSize.m:
        return 26;

      case spriteFrameSize.l:
        return 6;
    }
  }

  static getFramesPerColumn(size: SpriteFrameSize = spriteFrameSize.s) {
    switch (size) {
      case spriteFrameSize.xxs:
      case spriteFrameSize.xs:
      case spriteFrameSize.s:
      case spriteFrameSize.m:
        return 26;

      case spriteFrameSize.l:
        return 11;
    }
  }
}
